module.exports = __webpack_public_path__ + "static/media/urcode.82c5f12a.jpg";